import { useQuery } from "@tanstack/react-query";
import { useUniversalAuth } from "@west-tennessee-consulting/ui";

export function useTemplateGroups() {
  const { session } = useUniversalAuth();

  return useQuery({
    queryKey: ["template-groups"],
    queryFn: async () => {
      try {
        const token = session?.access_token;
        if (!token) {
          throw new Error("Authentication required");
        }

        const response = await fetch("/api/esignatures/template-groups", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(
            `Failed to fetch template groups: ${response.status} ${response.statusText}`
          );
        }

        const apiResponse = await response.json();
        return apiResponse.data;
      } catch (error) {
        console.error("Error fetching template groups:", error);
        throw new Error("SERVICE_UNAVAILABLE");
      }
    },
    enabled: !!session?.access_token,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: 1000,
  });
}

export function useTemplatesForGroup(groupId: string) {
  const { session } = useUniversalAuth();

  return useQuery({
    queryKey: ["templates-for-group", groupId],
    queryFn: async () => {
      try {
        const token = session?.access_token;
        if (!token) {
          throw new Error("Authentication required");
        }

        const response = await fetch(`/api/esignatures/template-groups/${groupId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(
            `Failed to fetch templates for group: ${response.status} ${response.statusText}`
          );
        }

        const apiResponse = await response.json();
        return apiResponse.data;
      } catch (error) {
        console.error("Error fetching templates for group:", error);
        throw error;
      }
    },
    enabled: !!session?.access_token && !!groupId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
